import React from "react";
import { useNavigate } from "react-router-dom";
import Badge from "../shared/Badge";
import ProgressBar from "../shared/ProgressBar";

const PanelHeader = ({ panel, status, progress }) => {
  const navigate = useNavigate();

  const getStatusBadge = (status) => {
    const statusConfig = {
      IN_REVIEW: { variant: "warning", label: "In Review" },
      DECISION_REACHED: { variant: "info", label: "Decision Reached" },
      PENDING_PUBLICATION: { variant: "purple", label: "Pending Publication" },
      PUBLISHED: { variant: "success", label: "Published" },
      CLOSED: { variant: "default", label: "Closed" },
    };

    const config = statusConfig[status] || statusConfig["IN_REVIEW"];
    return <Badge variant={config.variant}>{config.label}</Badge>;
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Panel Administration
          </h1>
          <h2 className="text-xl text-gray-700">{panel?.title}</h2>
          {/* Community/Description removed */}
          <div className="flex items-center space-x-4 mt-4">
            {getStatusBadge(status)}
            <span className="text-sm text-gray-500">
              Created: {panel?.createdDate}
            </span>
            <span className="text-sm text-gray-500">
              Deadline: {panel?.deadline}
            </span>
          </div>
        </div>
        <button
          onClick={() => navigate("/dashboard")}
          className="text-gray-500 hover:text-gray-700 transition-colors"
          aria-label="Close"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div className="mt-6">
        <ProgressBar value={progress} label="Panel Progress" />
      </div>
    </div>
  );
};

export default PanelHeader;
